import React, { useContext, useEffect, useState } from 'react';
import './TabAppealAnswer.scss';
import { Typography } from 'antd';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import { AppealAnswer } from '../../model/AppealAnswer';
import TabAppealAnswerCollapse from './TabAppealAnswerCollapse/TabAppealAnswerCollapse';
import { useAppeal } from '../../context/appeal/AppealContext';
import { Context } from '../../index';

interface TabAppealAnswerProps {
  appealId: number;
}

const TabAppealAnswer = (props: TabAppealAnswerProps): JSX.Element => {
  const [answers, setAnswers] = useState<AppealAnswer[]>([]);
  const { refreshAnswer, removeRefreshedAnswer } = useAppeal();
  const { store } = useContext(Context);

  useEffect(() => {
    store.getAppealAnswers(props.appealId).then((resp) => {
      if (resp) {
        setAnswers(resp);
      }
    });
  }, []);

  useEffect(() => {
    if (refreshAnswer.length && refreshAnswer.includes(props.appealId)) {
      store.getAppealAnswers(props.appealId).then((resp) => {
        if (resp) {
          setAnswers(resp);
          removeRefreshedAnswer(props.appealId);
        }
      });
    }
  }, [refreshAnswer]);

  return (
    <>
      {!answers.length ? (
        <LoaderSpinner />
      ) : (
        <div className="TabNotificationRowDirector">
          <div className="TabAppealAnswer">
            <div className="TabAppealAnswer__titles">
              <Typography.Text className="TabAppealAnswer__titles__message-title">
                <div>Уведомление</div>
              </Typography.Text>
              <Typography.Text className="TabAppealAnswer__titles__status">
                <div>Статус</div>
              </Typography.Text>
              <Typography.Text className="TabAppealAnswer__titles__date">
                <div>Дата создания</div>
              </Typography.Text>
            </div>
            {answers.map((item, index) => (
              <TabAppealAnswerCollapse
                appealId={props.appealId}
                appealAnswer={item}
                key={index}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TabAppealAnswer;
